import { useContext } from 'react';
import { createContext } from 'react';

import { OrderByV2Props } from '../@types/OrderByV2Props';

export const OrderByV2Context = createContext<OrderByV2Props>({} as OrderByV2Props);

OrderByV2Context.displayName = 'OrderByV2';

const OrderByV2Provider = (props: OrderByV2Props) => (
	<OrderByV2Context.Provider value={props}>{props.children}</OrderByV2Context.Provider>
);

export const useOrderByV2 = () => {
	const context = useContext(OrderByV2Context);

	return context;
};

export default OrderByV2Provider;
